import React from 'react';
import { FieldProps } from 'react-final-form';
import TimeInput from 'components/final-form/TimeInput';

export interface TimeFieldProps {
  name: string,
  component: any,
  size?: 'mini' | 'small' | 'large' | 'big' | 'huge' | 'massive',
  validate?: any,
  disabled?: boolean
}

interface ExtendedFieldProps extends FieldProps {
  size?: 'mini' | 'small' | 'large' | 'big' | 'huge' | 'massive'
}

export const timeFieldInput = (fields: ExtendedFieldProps): TimeFieldProps => {
  return {
    name: fields.name,
    component: TimeInput,
    size: fields.size,
    validate: fields.validate,
    disabled: fields.disabled,
  }
};
